import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ProfileService } from 'src/app/services/profile.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-list-of-transactions',
  templateUrl:  `./${environment.pageFolder}/list-of-transactions.${environment.pageFolder}.component.html`,
  styleUrls:  [`./${environment.pageFolder}/list-of-transactions.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [TranslateModule, CommonModule]
})
export class ListOfTransactionsComponent {
  @Input() events:any;
  loader = document.getElementById("loader-container");  
  ticketPdf: string = "";
  url:any;
  daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  constructor(private profileService: ProfileService) {}

  getTransactionInPdf(transID: string, transactionType: string) {
    this.profileService.getTransactionAndOpenPdf(transID, transactionType, this.loader!);
  }
}
